/**
 * "will-call" feature flag (PostHog): gates the profit-center will-call
 * dashboard (/pc/orders, "Order Status") while it's being rolled out.
 *
 * Single home for the flag name and for the PC landing route that depends on
 * it — when the dashboard is off, PC users land on the new-order page.
 */

import { useFeatureFlagEnabled } from "posthog-js/react";

export const WILL_CALL_FLAG = "will-call";

/** False while the flag is loading — gate UI entry points conservatively. */
export function useWillCallEnabled(): boolean {
  return useFeatureFlagEnabled(WILL_CALL_FLAG) ?? false;
}

/**
 * Raw flag state: undefined while PostHog is still loading. The dashboard
 * page itself uses this so enabled users aren't bounced during the load.
 */
export function useWillCallFlagState(): boolean | undefined {
  return useFeatureFlagEnabled(WILL_CALL_FLAG);
}

/** Where PC users land / go "back" to: the dashboard when enabled, else the order page. */
export function usePcHomeRoute(): string {
  return useWillCallEnabled() ? "/pc/orders" : "/pc/orders/new";
}
